import * as React from 'react';
import cx from 'classnames';
import { DialogTitleBar } from './DialogTitleBar.js';
import { DialogContent } from './DialogContent.js';
import { DialogBackdrop } from './DialogBackdrop.js';
import { DialogContext } from './DialogContext.js';
import { DialogButtonBar } from './DialogButtonBar.js';
import { DialogMain } from './DialogMain.js';
import { useMergedRefs, Box, Portal } from '../../utils/index.js';
import { Transition } from 'react-transition-group';
let DialogComponent = React.forwardRef((props, ref) => {
  let {
    trapFocus = false,
    setFocus = false,
    preventDocumentScroll = false,
    isOpen = false,
    isDismissible = true,
    closeOnEsc = true,
    closeOnExternalClick = false,
    onClose,
    isDraggable = false,
    isResizable = false,
    relativeTo = 'viewport',
    placement,
    className,
    portal = false,
    ...rest
  } = props;
  let dialogRootRef = React.useRef(null);
  return React.createElement(
    Transition,
    {
      in: isOpen,
      timeout: {
        exit: 600,
      },
      mountOnEnter: true,
      unmountOnExit: true,
    },
    React.createElement(
      DialogContext.Provider,
      {
        value: {
          isOpen,
          onClose,
          closeOnEsc,
          closeOnExternalClick,
          isDismissible,
          preventDocumentScroll,
          trapFocus,
          setFocus,
          isDraggable,
          isResizable,
          relativeTo,
          dialogRootRef,
          placement,
        },
      },
      React.createElement(
        Portal,
        {
          portal: portal,
        },
        React.createElement(Box, {
          className: cx('iui-dialog-wrapper', className),
          'data-iui-relative': 'container' === relativeTo,
          ref: useMergedRefs(ref, dialogRootRef),
          ...rest,
        }),
      ),
    ),
  );
});
export const Dialog = Object.assign(DialogComponent, {
  Backdrop: DialogBackdrop,
  Main: DialogMain,
  TitleBar: DialogTitleBar,
  Content: DialogContent,
  ButtonBar: DialogButtonBar,
});
